import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-add-reference-card',
  templateUrl: './add-reference-card.component.html',
  styleUrls: ['./add-reference-card.component.scss'],
})
export class AddReferenceCardComponent {
  @Input() desc: string = '';
  @Input() btnLabel: string = '';
  @Input() btnLabelTwo: string = '';
  @Output() btnClickHandler = new EventEmitter<void>();
  @Output() recAclAslHandler = new EventEmitter<void>();
  @Input() isBudgetSummary: boolean = false;
  @Input() hasExtraButton: boolean = false;
  @Input() disabled: boolean = false;
  @Input() icon: string = '';
  @Input() iconTwo: string = '';
  @Input() type: string = 'flat-button';

  constructor(private iconRegistry: MatIconRegistry, private santitizer: DomSanitizer) {
    this.iconRegistry.addSvgIcon(
      'reference',
      this.santitizer.bypassSecurityTrustResourceUrl('/assets/images/emptyState.svg')
    );
  }

  handleClick(): void {
    this.btnClickHandler.emit();
  }

  handleAclAsl(): void {
    this.recAclAslHandler.emit();
  }
}
